// actions.js
export const INIT_USER_LIST_REQUEST = 'INIT_USER_LIST_REQUEST';
export const SET_USER_LIST = 'SET_USER_LIST';
export const ERROR_USER_LIST = 'ERROR_USER_LIST';

export const INIT_USER_REQUEST = 'INIT_USER_REQUEST';
export const SET_USER = 'SET_USER';
export const ADD_USER = 'ADD_USER';
export const UPDATE_USER = 'UPDATE_USER'; 
export const ERROR_USER_REQUEST = 'ERROR_USER_REQUEST';

export function initUserListRequest() {
  return { type: INIT_USER_LIST_REQUEST };
}

export function setUserList(data) {
  return { type: SET_USER_LIST, payload: data };
}

export function errorUserList(error) {
  return { type: ERROR_USER_LIST, payload: error };
}

export function addUser() {
  return { type: ADD_USER };
}

export function updateUser(user) {
  return { type: UPDATE_USER, payload: user };
}

export function initUserRequest() {
  return { type: INIT_USER_REQUEST };
}

export function setUser(data) {
  return { type: SET_USER, payload: data };
}

export function errorUserRequest(error) {
  return { type: ERROR_USER_REQUEST, payload: error };
}
